import { render, staticRenderFns } from "./ReferralExport.vue?vue&type=template&id=012d90c1"
import script from "./ReferralExport.vue?vue&type=script&lang=js"
export * from "./ReferralExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports